import React, { Component } from 'react';
import Logo from '../../img/logo.svg'

export default class Landingpage extends Component {
  state = {
    class:"trans"
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        class:"landing-logo"
      });
    },500)
  }
  render() {
    return (
      <div className="container-fullWidth fullScreen">
        <img className={this.state.class} src={Logo}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/landingpage.js